import { createContext } from "react";
export var TextMapContext = createContext([{}, 'ko']);
export var PopupContext = createContext(null);
export var Web3Context = createContext(null);
export var AddressContext = createContext(['', function () { }]);
export var NetworkIdContext = createContext([-1, function () { }]);
export var FeedBalanceContext = createContext([0, function () { }]);
